/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Public_Upgrade_DescriptionInputs */

const en_pricing_public_upgrade_description = /** @type {(inputs: Pricing_Public_Upgrade_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a credit pack or subscription without leaving your current workspace.`)
};

const es_pricing_public_upgrade_description = /** @type {(inputs: Pricing_Public_Upgrade_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige un paquete de creditos o una suscripcion sin salir del workspace actual.`)
};

/**
* | output |
* | --- |
* | "Choose a credit pack or subscription without leaving your current workspace." |
*
* @param {Pricing_Public_Upgrade_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_public_upgrade_description = /** @type {((inputs?: Pricing_Public_Upgrade_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Public_Upgrade_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_public_upgrade_description(inputs)
	return es_pricing_public_upgrade_description(inputs)
});